import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
// eslint-disable-next-line
export const sectionJSkipPatterns = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        // eslint-disable-next-line
        const payload = input;
    }
    else if (!field) {
        // section level
        const payload = input;
        // J-skip pattern-5630 (a) If J1800=[0], then all active items from J1900A through J1900C must equal [^].
        if (payload?.j1800 === '0' && [payload.j1900?.a, payload.j1900?.b, payload.j1900?.c].some((item) => Boolean(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5070 (a) If J1800 is 0, then all items from J1900A through J1900C must be empty.',
                path: ['j1800'],
            });
        }
        // J-skip pattern-5630 (b) If J1800=[1], then all active items from J1900A through J1900C must not equal [^] and at least one of these items must equal [-,1,2].
        if (payload?.j1800 === '1' && [payload.j1900?.a, payload.j1900?.b, payload.j1900?.c].some((item) => !item)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5070 (b) If J1800 = 1, then all items from J1900A through J1900C must NOT be empty',
                path: ['j1800'],
            });
        }
        // J-skip pattern-5630 (c) If J1800=[-], then all active items from J1900A through J1900C must equal [-].
        if (payload?.j1800 === '-' && [payload.j1900?.a, payload.j1900?.b, payload.j1900?.c].some((item) => item !== '-')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5070 (c) If J1800 = -, then all active items from J1900A through J1900C must equal -.',
                path: ['j1800'],
            });
        }
    }
    else {
        // field level
    }
};
// J-skip pattern-5630
// (a) If J1800=[0], then all active items from J1900A through J1900C must equal [^].
// (b) If J1800=[1], then all active items from J1900A through J1900C must not equal [^] and at least one of these items must equal [-,1,2].
// (c) If J1800=[-], then all active items from J1900A through J1900C must equal [-].
